export const thongTinXuatHoaDon = {
  sections: {
    list: { title: 'Invoice info' },
  },
  fields: {
    customerId: 'Customer (ID)',
    customer: 'Customer',
    ten: 'Tax company name',
    buyerName: 'Buyer name',
    taxCode: 'Tax code',
    invoiceAddress: 'Tax invoice address',
    invoiceProvince: 'Province/City',
    invoiceWard: 'Ward/Commune',
    soCCCD: 'ID No.',
    soHoChieu: 'Passport No.',
    invoiceEmail: 'Invoice email',
    invoicePhone: 'Company phone',
    daiDienCongTy: 'Company representative',
    chucVu: 'Title',
    bankName: 'Bank name',
    bankAccount: 'Account No.',
    bankAccounts: 'Bank accounts',
    bankAccountCount: '{count} accounts',
    accountHolder: 'Account name',
    default: 'Default account',
    defaultCompany: 'Default invoice company',
    defaultYes: 'Default',
    defaultNo: '—',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actions: 'Actions',
  },
  actions: {
    addStk: 'Add account',
    removeStk: 'Remove account',
  },
  inline: {
    itemTitle: 'Invoice company',
  },
  filter: {
    searchPlaceholder: 'Company name, tax code or phone',
    customerPlaceholder: 'Search customer…',
    defaultAll: 'All',
    defaultYes: 'Default company only',
    defaultNo: 'Non-default',
  },
  import: {
    failed: 'Import failed',
    menu: {
      cty: 'Import tax companies',
      taiKhoan: 'Import bank accounts',
      ctyTaiKhoan: 'Combined import (companies + accounts)',
    },
  },
  placeholders: {
    provinceEmpty: '— Select Province/City —',
    wardEmpty: '— Select Ward/Commune —',
    ten: 'e.g. ABC Co., Ltd.',
  },
  titles: {
    add: 'Add invoice company',
    edit: 'Edit invoice company',
  },
  messages: {
    noData: 'No data',
    loadError: 'Failed to load data',
    invalidContext: 'A valid customer ID is missing on the URL.',
    customerRequired: 'Please select a customer.',
    createSuccess: 'Invoice info created',
    updateSuccess: 'Invoice info updated',
    deleteSuccess: 'Invoice info deleted',
    notFound: 'Invoice info not found',
    confirmDelete: 'Delete invoice info «{name}»?',
    listSummary: '{count} invoice companies',
  },
}
